

















































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { demoServer, hiddenDangerLibraryServer, performanceServer, yunnanDataViewServer } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
// import DetailsDialogA from './box-4-2-unit-3.vue';
import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';

@Component({
  components: { PagingUnit, ViewDialog },
  mixins: [TableStripe],
})
export default class Home extends Vue {
  private visible = false;
  private title: any = '履责列表';
  private total: any = 0;
  private tableData: any = [];
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  rowData: any = {};

  loading: any = false;
  searchFinish: any = '';

  finishOptions: any = [
    { label: '超期完成', value: 'overdueFinishTotal' },
    { label: '如期完成', value: 'scheduledFinishTotal' },
    { label: '未完成', value: 'unFinishTotal' },
    { label: '待完成', value: 'waitFinishTotal' },
  ];

  private mounted() {}

  private async showDialog(data: any) {
    this.rowData = data;
    this.visible = true;
    this.searchFinish = data.totalType;
    this.changeFilter();
  }

  getTime(newDate: any) {
    const date = new Date(newDate); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    // const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // const Ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return SY + '-' + SM + '-' + SD;
  }

  setStateColor(state: any) {
    switch (state) {
      case '已完成':
        return '#19dd19';
        break;
      case '待审批':
        return '#FF8F1B';
        break;
      case '待接收':
        return '#FF2F2F';
        break;
      case '待完成':
        return '#4C64FE';
        break;
    }
  }

  viewManagement(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  changeFilter() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getDataDanger();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getListData() {
    this.getDataDanger();
  }

  private getDataDanger() {
    yunnanDataViewServer
      .getProfessionStatisticsNumberList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        totalType: this.searchFinish,
        deptId: this.rowData.deptId,
        year: new Date().getFullYear(),
      })
      .then((res: any) => {
        this.loading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private hideDialog() {
    this.visible = false;
  }
}
